import { render } from "./SearchReport.vue?vue&type=template&id=38cdc3a0&scoped=true"
import script from "./SearchReport.vue?vue&type=script&lang=js"
export * from "./SearchReport.vue?vue&type=script&lang=js"

import "./SearchReport.vue?vue&type=style&index=0&id=38cdc3a0&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cdc3a0"]])

export default __exports__